export default __webpack_public_path__ + "static/media/AgC_Logo.02a8a49d.jpg";